export default "__VITE_ASSET__ycmgrcj3__"